// const endpoint = 'https://api.nexstoreapp.com/api'
const endpoint = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8003/api'

export default endpoint